const FAQ_ITEMS = [
  {
    q: '97影视上的电影需要付费观看吗？',
    a: '完全不需要！97影视所有电影资源均为免费在线观看，无需注册、无需付费、无需VIP会员。我们致力于为影迷提供最便捷的免费观影体验。',
  },
  {
    q: '播放电影时会不会卡顿或缓冲？',
    a: '97影视采用先进的极速播放引擎和多线路智能切换技术，根据您的网络环境自动优化播放质量。无论是高峰期还是普通时段，都能保持流畅播放体验。',
  },
  {
    q: '电影画质怎么样？有高清版本吗？',
    a: '我们提供从标清到1080P超清多种画质选择，大部分最新电影都支持高清甚至超清画质。您可以根据自己的网络状况和设备性能自由选择合适的画质。',
  },
  {
    q: '新电影更新速度快吗？',
    a: '非常快！97影视拥有专业的片源更新团队，每日不间断更新最新电影资源。热门动作片、喜剧片通常在院线下映后第一时间上线，让您最快看到想看的电影。',
  },
  {
    q: '手机和平板可以观看吗？',
    a: '完全可以！97影视全面适配移动端设备，支持iOS和Android系统的手机和平板。只需打开浏览器访问即可直接观看，无需下载任何APP，支持横屏全屏播放。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于97影视，您想了解的都在这</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {FAQ_ITEMS.map((item) => (
            <div
              key={item.q}
              className="bg-background-50 border border-background-200/60 rounded-lg p-5"
            >
              <h3 className="text-sm font-semibold text-foreground-800 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line" />
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}